module.exports = __webpack_public_path__ + "03_very_short_brown.54c0f878.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/03_very_short_brown.png
// module id = gPje
// module chunks = 0